// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".switch-input .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {\n  background: var(--sea);\n}\n.switch-input .p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover .p-inputswitch-slider {\n  background: var(--sea);\n}\n.switch-input .p-inputswitch.p-focus .p-inputswitch-slider {\n  box-shadow: none;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
